mainApp.directive('remotePortForwardingRule', function(){
    return {
        templateUrl: '/public/directives/remotePortForwardingRule.html',
        scope: {
            portForwarding: '=',
            datamodified: "=",
            errors: "=",
            locations: "=",
            addIp: "&",
            mailingLists: "=",
            id: '@',
            admins: "=",
            account: "=",
            allocatedIps: "=",
        },
        controller: ['$scope', 'GeneralUtilsService', 'ValidationService', 'LocationService',  function($scope, GeneralUtilsService, ValidationService, LocationService){

            $scope.admins = $scope.admins || [];
            $scope.timeConstraints = {"type":"always","timeDef":{"isA":"Time","days":[],"times":[],"reoccurring":true}};
            $scope.popup = false;

            // For ALERTS
            $scope.frequencies = ['IMMEDIATE', 'HOURLY', 'DAILY',  'WEEKLY'];

            $scope.rpfAllocatedIps = [];
            LocationService.getAllocatedIpsWithLocations($scope.account.id, function(items) {
                $scope.rpfAllocatedIps = angular.copy(items);
                $scope.$digest();
            }, true);

            var allowedRemoteIpsTemplate = `
                <div class='row remoteIpsTableColumn'>
                    <div class='col-sm-2 iconColumn'>
                        <div ng-if='tableConfig.isAnyAllowedValue(item.allowedRemoteIps).isValid' class="more-warning cato-tooltip" data-type="WARNING" data-title="{{tableConfig.isAnyAllowedValue(item.allowedRemoteIps).message}}">
                            <span class='glyphicon glyphicon-warning-sign iconClass'></span>
                        </div>
                    </div>
                    <div class='col-sm-10 textColumn'>
                        <span><input type='text' class='form-control' ng-model='item.allowedRemoteIps' placeholder='68.89.31.226,68.89.31.227(optional)'/></span>
                    </div>
                </div>
                `;

            // table of ports for specific public IP
            $scope.portForwardingConfig = {
                id: "remotePortForwarding",
                dataURL : function(){
                    return null;
                },
                parseData : function() {
                    if ($scope.portForwarding && $scope.portForwarding.portForwardingMetadata) {
                        if (!$scope.portForwarding.portForwardingMetadata.portItems[$scope.id]) {
                            return [];
                        }
                        return $scope.portForwarding.portForwardingMetadata.portItems[$scope.id];
                    }
                    return [];
                },
                fields : [
                    {"label":"Name","path":"name","template":"<span><input type='text' class='form-control' ng-model='item.name' /></span>"},
                    {"label":"External Port","path":"externalPort","template":"<span><input type='text' class='form-control' ng-model='item.externalPortRange' placeholder='8000-8002' ng-change='tableConfig.updateInternalPort(item)' /></span>"},
                    {"label":"Internal IP","path":"internalIp","template":"<span><input type='text' class='form-control' ng-model='item.internalIp' /></span>"},
                    {"label":"Forward ICMP","path":"forwardICMP","template":"<div class='checkbox'><label><input type='checkbox' ng-model='item.forwardICMP' /></label></div>"},
                    {"label":"Internal Port","path":"internalPort","template":"<span><input type='text' class='form-control' ng-model='item.internalPortRange'  placeholder='8000-8002' /></span>"},
                    {"label":"Allowed Remote IPs","path":"allowedRemoteIps","template": allowedRemoteIpsTemplate},
                    {"class":"constraint","label":"Limit to","path":"constraint","template":"<span><constraint id=\"'constraint'\" item='item' config='tableConfig' index='$parent.id'/></span>",noSort:true},
                    {"label":"Track","path":"track",
                        template:   `<div id='trigger_{{$parent.id}}_{{$parent.$parent.$index}}' class='inline-block' ng-click='tableConfig.editTrigger(item,tableConfig.ruleAction + $parent.id, $parent.$parent.$index)'>
                                        <span ng-show='!item.trigger' class='action-link'>Select</span>
                                        <span ng-show='item.trigger'>
                                            <span class='glyphicon glyphicon-alert'></span>&nbsp;
                                            <span class='action-link'>Alert:{{item.alertFrequency | capitalize}}</span>
                                        </span>
                                    </div>`,noSort:true}
                ],
                actions : [],
                addAction : function(){
                    if (!$scope.portForwarding || !$scope.portForwarding.portForwardingMetadata) {
                        return;
                    }
                    if (!$scope.portForwarding.portForwardingMetadata.portItems[$scope.id]) {
                        $scope.portForwarding.portForwardingMetadata.portItems[$scope.id] = [];
                    }
                    $scope.portForwarding.portForwardingMetadata.portItems[$scope.id].push({id:GeneralUtilsService.getRandomId(), name: "", allowedRemoteIps: "0.0.0.0/0"});
                    $scope.datamodified = new Date().getTime();
                },
                specialActions : [
                    {"func":function(selectedItems) {
                        selectedItems.forEach(function(item) {
                            for(var i = 0 ; i < $scope.portForwarding.portForwardingMetadata.portItems[$scope.id].length ; i++){
                                var subnet = $scope.portForwarding.portForwardingMetadata.portItems[$scope.id][i];
                                if(subnet.id === item.id){
                                    $scope.portForwarding.portForwardingMetadata.portItems[$scope.id].splice(i,1);
                                    break;
                                }
                            }
                        });
                    },"icon":"delete",tooltip:"Delete"}
                ],
                editTrigger:function(item, id, index){
                    $scope.editTrigger(item, id, index);
                },
                editConstraints: function(item,id){
                    $scope.popup=true;
                    if(!item.constraint){
                        item.constraint = {"predicates":[],"op":"OP_LE"};
                    }
                    $scope.timeConstraints = {"type":"always","timeDef":{"isA":"Time","days":[],"times":[],"reoccurring":true}};
                    if (item.constraint.predicates["time"]) {
                        item.constraint.predicates["time"].values.forEach(function(value) {
                            if(typeof value == "string"){
                                $scope.timeConstraints['type'] = value;
                            }
                            else {
                                $scope.timeConstraints['type'] = "custom";
                                $scope.timeConstraints['timeDef'] = value;
                            }
                        });
                    }
                    $scope.scopeSelection = {"item":item};
                    $scope.$root.openPopup("constraintEditor" + $scope.id);
                },
                updateInternalPort: function(item){
                    // use the external port as internal port if nothing else is defined
                    item.internalPortRange = item.externalPortRange;
                },
                selectedItems:[],
                pageSize:10,
                noSearch:true,
                isAnyAllowedValue: ValidationService.isAnyIpAllowed,
            };


            // Open alert dialog
            $scope.editTrigger = function(item, id, index){
                $scope.$root.$emit("$openPopup","triggerSelector" + $scope.id,"trigger_" + id + "_" + index, {topMod: -110, leftMod: -560, simplePosition: false, rightArrow: true});
                var alertFrequency = item.alertFrequency ? item.alertFrequency : "HOURLY";
                var addresses      = item.addresses ? item.addresses : "All Admins";
                $scope.scopeSelection = {"item": item,"trigger": item.trigger,"alertFrequency":alertFrequency,"addresses":addresses};
            };

            // Close alert dialog
            $scope.saveTrigger = function(trigger){
                $scope.scopeSelection.item.trigger = $scope.scopeSelection.trigger;
                if($scope.scopeSelection.trigger || trigger) {
                    $scope.scopeSelection.item.alertFrequency = $scope.scopeSelection.alertFrequency;
                    $scope.scopeSelection.item.addresses = $scope.scopeSelection.addresses;
                }
                $scope.$root.$emit("$closePopup","triggerSelector" + $scope.id);
            };

            // time constraints
            $scope.addConstraints = function(){
                var item = $scope.scopeSelection.item;
                item.constraint.predicates = {};

                if($scope.timeConstraints['type'] == "always"){
                    delete item.constraint.predicates["time"];
                }
                else if($scope.timeConstraints['type'] == "workingHours"){
                    item.constraint.predicates["time"] = {"field":{name:"dst_time"},"op":"OP_LE","values":["workingHours"]};
                }
                else { //custom
                    item.constraint.predicates["time"] = {"field":{name:"dst_time"},"op":"OP_LE","values":[$scope.timeConstraints.timeDef]};
                }

                $scope.$root.closePopup("constraintEditor" + $scope.id);
            };

            $scope.checkClearAllocatedIP = function() {
                if ($scope.portForwarding.portForwardingMetadata.ips[$scope.id].id === null) {
                    $scope.portForwarding.portForwardingMetadata.ips[$scope.id].externalIp = null;
                    $scope.portForwarding.portForwardingMetadata.ips[$scope.id].locationId = null;
                    $scope.portForwarding.portForwardingMetadata.ips[$scope.id].popId = null;
                }
            };
        }]
    };
});
